import { chakra } from '@chakra-ui/react'

export const HiddenInPC: React.FC = ({ children }) => {
  return <chakra.div d={['initial', 'none']}>{children}</chakra.div>
}
